import firebaseService from 'infrastructure/FirebaseService'
import N from 'const/namespace'
import profanity from 'const/profanity'

const hasInvalidCharacters = (username) => {
  return username.includes('.')
}

const profane = (username) => {
  return profanity.filter((profaneWord) => {
    return username.toLowerCase().includes(profaneWord.toLowerCase())
  })
}

const unique = (username) => {
  return firebaseService.once(
    'usernames/' + username,
    N.GAMERS
  ).then(value => {
    let usernameTaken
    if (value) {
      usernameTaken = true
    } else {
      usernameTaken = false
    }
    return !usernameTaken
  })
}

const valid = (username) => {
  let invalidUsername
  if (hasInvalidCharacters(username)) {
    invalidUsername = true
  } else if (profane(username).length) {
    invalidUsername = true
  } else {
    return unique(username).then(uniquenessValue => {
      return uniquenessValue
    })
  }

  return new Promise((resolve, reject) => {
    resolve(!invalidUsername)
  })
}

exports.hasInvalidCharacters = hasInvalidCharacters
exports.profane = profane
exports.unique = unique
exports.valid = valid



// WEBPACK FOOTER //
// ./src/app/const/usernames.js